// src/tenant-products/builder-dev-sync-bus.ts
var syncSuppressed = false;
function runWithoutBuilderDevSync(fn) {
  syncSuppressed = true;
  try {
    fn();
  } finally {
    syncSuppressed = false;
  }
}
function isBuilderDevSyncSuppressed() {
  return syncSuppressed;
}
var listeners = /* @__PURE__ */ new Set();
function onBuilderStateDirty(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
function markBuilderStateDirty() {
  if (syncSuppressed) return;
  for (const listener of listeners) listener();
}

export {
  runWithoutBuilderDevSync,
  isBuilderDevSyncSuppressed,
  onBuilderStateDirty,
  markBuilderStateDirty
};
